// Converts a string, including strings in camelCase or snake_case, into Start Case (a variant
// of Title Case where all words start with a capital letter), it keeps original single quote
// and hyphen in the word.
// 'management_companies' to 'Management Companies'
// 'managementCompanies' to 'Management Companies'
// `hell's kitchen` to `Hell's Kitchen`
// `co-op` to `Co-op`

export const startCase = (str) => {
    return str
        .replace(/_/g, ' ')
        .replace(/([a-z])([A-Z])/g, (str, $1, $2) => { return `${$1} ${$2}`; })
        .replace(/(\s|^)(\w)/g, (str, $1, $2) => { return $1 + $2.toUpperCase(); });
};


// Generate a random string made with numbers!
export const randomString = (length = 5) => { return Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, length); };

// Refer to Lodash for other string functions
// https://lodash.com/docs/4.17.11

// import { camelCase, capitalize, kebabCase, snakeCase } from 'lodash'
